export default {
  userProfile: '',
  userNotifID: ''
};